import React from "react";
import { Redirect, Route } from "react-router-dom";
import { LOGIN } from "routes";

const CustomRoute = ({ component: Component, restricted, path, ...rest }) => {
  const authenticated = localStorage.getItem("token");

  return (
    <Route
      // restricted = false meaning public route
      // restricted = true meaning restricted route
      {...rest}
      render={(props) =>
        authenticated && restricted ? (
          <Component {...props} />
        ) : (
          <Redirect to={LOGIN} />
        )
      }
    />
  );
};

export default CustomRoute;
